import miscService from "../events/misc";

export default {
  install(Vue) {

    Vue.prototype.$misc = miscService;

    Vue.mixin({
      created() {
        if (this.handleLocaleEvent) {
          miscService.addListener("localeEvent", this.handleLocaleEvent);
        }
        if (this.handleFormGroupEvent) {
          miscService.addListener("formGroupEvent", this.handleFormGroupEvent);
        }
      },

      destroyed() {
        if (this.handleLocaleEvent) {
          miscService.removeListener("localeEvent", this.handleLocaleEvent);
        }
        if (this.handleFormGroupEvent) {
          miscService.removeListener("formGroupEvent", this.handleFormGroupEvent);
        }
      }
    });
  }
};
